import { useMap } from '@vis.gl/react-google-maps';
import { useEffect } from 'react';
import { useGeoPosition } from '@repo/geo-position';
import { googleCoordinates } from '../utils/googleCoordinates';
export default function MapController({ mapNodeId }) {
    const { isKnown, position, isFollowing, setIsFollowing, setRepanFunction } = useGeoPosition();
    const map = useMap(mapNodeId);
    useEffect(() => {
        if (!map)
            return;
        setRepanFunction(() => (toPosition, zoom) => {
            if (toPosition) {
                map.panTo(googleCoordinates(toPosition));
            }
            else if (isKnown && position) {
                map.panTo(googleCoordinates(position));
            }
            if (zoom)
                map.setZoom(zoom);
        });
    }, [map, isKnown, position, setRepanFunction]);
    // While following, keep the map centered on the user by panning on every position change.
    useEffect(() => {
        if (!map || !isFollowing || !position)
            return;
        map.panTo(googleCoordinates(position));
    }, [map, isFollowing, position]);
    // A manual drag breaks the follow bond. `dragstart` fires only for user drags, not programmatic panTo.
    useEffect(() => {
        if (!map)
            return;
        const listener = map.addListener('dragstart', () => setIsFollowing(false));
        return () => listener.remove();
    }, [map, setIsFollowing]);
    return null;
}
